<template>
  <v-dialog v-model="dialog" persistent>
    <v-card 
      align="center" 
      class="rounded-card" 
    >
      <v-container>
        <div>
          <span
            class="header-title" 
            :style="`color: ${$partnerACL.getBackgroundColorApp()}`"
          >{{ $t("DetailTicket") }}</span>
        </div>

        <div class="d-flex flex-column text-left mt-4" style="line-height: 1.2;">
          <span class="f-s-sm">{{ $t("TicketMultiTrip") }}</span>
          <span class="f-s-sm f-bold">{{ routeTitle }}</span>
        </div>
        
        <div class="dots-line mt-2" style="margin: 0px -12px;"/>

        <div class="mt-2 text-left">
          <span class="f-bold f-s-xs">{{ $t("DescriptionTicket") }}:</span>

          <div>
            <ul class="f-s-xs pl-4">
              <li v-for="(item, index) in descriptionTicket"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>

        <div class="dots-line mt-2" style="margin: 0px -12px;"/>

        <div class="mt-2 text-left">
          <span class="f-bold f-s-xs">{{ $t("TheRouteFollowed") }}:</span>
          
          <div
            class="d-flex flex-column" 
            style="gap: 8px;"
          >
            <div v-for="(route, index) in routeLoc"
              :key="index"
              style="line-height: 1;"
            >
              <span class="f-bold f-s-xs">{{ route.route_long_name }}</span>
              <br/>
              <span v-for="(trip, index2) in route.trips" :key="index2">
                <span v-for="(tripDetail, index3) in trip.trip_route.filter(fx => fx != null)" 
                  :key="index3"
                  class="f-s-xs"
                  :style="`color: ${$partnerACL.getBackgroundColorApp()}`"
                >
                  {{ tripDetail }} 
                  <span v-if="index3 != trip.trip_route.filter(fx => fx != null).length-1" 
                    class="px-1"
                  >-</span> 
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="my-2">
          <span class="num-135000-v-nd">{{ new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: selectedCurrency,
            minimumFractionDigits: 2
          }).format(price) }}</span>
        </div>

        <!-- <p class="header-title mb-0" align="center">{{$t("MultiTripsInfo")}}</p> -->
        <!-- <v-row align="center" class="ma-0 pa-4 pb-0 pt-0">
          <v-col class="ma-0 px-0 py-5 d-flex text-center justify-center" cols="12">
            <h2 class="pl-1 ticket">
              {{$t("TicketInformation")}}
            </h2>
          </v-col>
        </v-row> -->
        <!-- <v-row style="border-top: 1px solid #cecece;">
          <v-col>
            <b style="font-size: 16px;color: rgba(0, 0, 0, 0.8);">{{$t("TripInformation")}}</b>
            <p v-if="fareRule.max_trip == 0 & fareRule.max_trip_perday == 0" class="mb-0"> {{$t("UnlimitedTrips")}} - {{$t("UnlimitedDays")}}</p>
            <p v-else-if="fareRule.max_trip == 0 & fareRule.max_trip_perday != 0" class="mb-0"> {{$t("UnlimitedTrips")}} -   {{$t("Maximum")}} {{fareRule.max_trip_perday}} {{$t("TripPerDay")}}</p>
            <p v-else-if="fareRule.max_trip != '' & fareRule.max_trip_perday == 0" class="mb-0">  {{$t("Maximum")}} {{fareRule.max_trip}} {{$t("Trips")}} - {{$t("UnlimitedDays")}}</p>
            <p v-else class="mb-0"> {{$t("Maximum")}} {{fareRule.max_trip}} {{$t("Trips")}} - {{fareRule.max_trip_perday}} {{$t("TripPerDay")}}</p>
            <p class="mb-0">Multi day ticket is valid for {{fareRule.valid_days}} days</p>
            <p class="mb-0"> {{$t("Price")}}: {{ Intl.NumberFormat('de-DE', { style: 'currency', currency: currencyCode || 'USD' }).format(price) }} / {{ $t("Turn") }}<br /></p>
            <p class="mb-0"> {{$t("ValidUntil")}}: {{ fareRule.validate_close_date }}</p>
                  
          </v-col>
        </v-row> -->
        
        <!-- <v-row class="text-left">
          <v-col class="" v-for="(route, index) in routeLoc" :key="index" cols="12">
            <span class="body-2 font-weight-bold">{{route.route_long_name}}</span>
            <p class="detail-route text-justify mb-0">
              <span v-for="(trip, index2) in route.trips" :key="index2">
                <span v-for="(tripDetail, index3) in trip.trip_route" :key="index3">
                  {{ tripDetail }} 
                  <span v-if="index3!=trip.trip_route.length-1" class="px-1">-</span> 
                </span>
              </span>
            </p>
          </v-col>
        </v-row> -->
        
        <!-- <v-row >
          <v-col v-if="expiredNote === 'ExpiredOnSameDay'" class="d-flex justify-center">
            <p class="detail-route black--text mb-0 font-weight-black">
              {{ $t("ExpiredOnSameDay") }}
            </p>
          </v-col>
          <v-col
            v-else-if="expiredNote === 'ExpiredAfterPurchase'"
            class="d-flex justify-center"
          >
            <p class="detail-route black--text mb-0 font-weight-black">
              {{ $t("ValidFor") }} {{ fareRule.valid_days }} {{ $t("Days") }}
            </p>
          </v-col>
          <v-col
            v-else-if="expiredNote === 'ExpiredAfterUsage'"
            class="d-flex justify-center"
          >
            <p class="detail-route black--text mb-0 font-weight-black">
              {{ $t("ValidFor") }} {{ fareRule.valid_days }} {{ $t("ExpiredAfterUsage") }}
            </p>
          </v-col>
          <v-col
            v-else-if="expiredNote === 'ValidationPeriod' && fareRule.validate_close_date != ''"
            class="d-flex justify-center"
          >
            <p class="detail-route black--text mb-0">
              <span class="font-weight-black">{{ $t("ValidFor") }} </span><br/>
              {{ fareRule.validate_open_date + " " }}
              {{ '(' + fareRule.validate_open_time +') ' }}
              {{ $t("to") + " " + fareRule.validate_close_date + " " }} 
              {{ fareRule.validate_close_time ? '(' + fareRule.validate_close_time + ') ' : '(23:59:59)' }}
            </p>
          </v-col>
          <v-col
            v-else-if="expiredNote === 'ValidationPeriod' && fareRule.validate_close_date == ''"
            class="d-flex justify-center"
          >
            <p class="detail-route black--text mb-0">
              <span class="font-weight-black">{{$t("ValidFrom")}} </span><br/>
              {{ " " + fareRule.validate_open_date + ", " }}
              {{ " " + fareRule.validate_open_time + " " }}
            </p>
          </v-col>
          <v-col v-else-if="expiredNote === 'Unlimited'" class="d-flex ma-0">
            <p class="detail-route black--text mb-0 font-weight-black"></p>
          </v-col>
          <v-col v-else class="d-flex ma-0">
            <p class="detail-route black--text mb-0 font-weight-black"></p>
          </v-col>
        </v-row>
        <v-row class="mb-5">
        </v-row> -->

        <div align="center">
          <v-spacer></v-spacer>
          <ac-button 
            :name="$t('Close')" 
            :on-click-handler="clickClose"
          />
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import AcButton from "@/components/AcButton.vue";
import moment from "moment";
export default {
  name: "RouteInformation",
  components: { AcButton },
  props: {
    routeTitle: {
      /*
        Description message
      */
      type: String,
      default: "Route 1 Bến Thành - Bến Xe buýt Chợ Lớn"
    },
    expiredNote: {
      type: String,
    },
    currencyCode: {
      type: String,
    },
    price: {
      type: Number,
    },
    fareRule: {
      type: Object,
      default: () => {
        return {
          max_trip: 0,
          valid_days: 0,
          max_trip_perday: 0,
          selling_open_date: null,
          selling_open_time: null,
          selling_close_date: null,
          selling_close_time: null,
          validate_open_date: null,
          validate_open_time: null,
          expired_after_usage: 0,
          expired_on_same_day: false,
          validate_close_date: null,
          validate_close_time: null
        }
      }
    },
    routeLoc: {
      type: Array,
      default: () => []
    },
    dialog: {
      /*
        set open dialog
      */
      type: Boolean,
      required: true,
      default: false,
    },
    btnClose: {
      type: Function,
      required: false,
    },
  },
  methods: {
    clickClose() {
      this.$store.commit("moduleUi/ROUTE_INFORMATION", "");
    },
  },
  computed: {
    descriptionTicket() {
      /** Description Available
       * 
       * 1. Tiket dapat dipakai hingga batas akhir masa penggunaan pengunaan tiket (5 Agustus 2025). -> UnlimitedTripDesc
       * 1,1. Tiket berlaku untuk maksimum 35 kali perjalanan -> MaxTripTicketDesc
       * 1,2. Tiket dapat dipakai hingga batas akhir yang tidak ditentukan -> UnlimitedTripWithoutCloseDesc
       * 2. Tiket berlaku maksimum 3 kali perjalanan dalam satu hari. -> UnlimitedTripPerDayDesc
       * 2.1 Tiket ada batasan pemakaian dalam satu hari. -> MaxTripPerDayDesc
       * 3. Masa pembelian tiket maksimal pada tanggal 30 Juli 2025. -> SellingPeriodDesc
       * 4. Masa penggunaan tiket tanggal 1 - 5 Agustus 2025 -> ValidationPeriodDesc
       * 4.1 Masa Penggunaan tiket mulai pada tanggal 1 Agustus 2025 -> ValidationPeriodWihoutCloseDesc
       * 
       */

      let descTicket = []
      if (this.fareRule.max_trip == 0 && (this.fareRule.selling_close_date == null || this.fareRule.selling_close_date == "")) { 
        descTicket.push(this.$t("UnlimitedTripWithoutCloseDesc"))
      } else if (this.fareRule.max_trip == 0 && (this.fareRule.selling_close_date != null && this.fareRule.selling_close_date != "")) {
        descTicket.push(this.$t("UnlimitedTripDesc").replace("[date]", moment(this.fareRule.selling_close_date).format("DD MMMM YYYY")))
       } else if (this.fareRule.max_trip > 0) {
        descTicket.push(this.$t("MaxTripTicketDesc").replace("[num]", this.fareRule.max_trip))
      }

      if (this.fareRule.max_trip_perday == 0) { 
        descTicket.push(this.$t("MaxTripPerDayDesc"))
      } else {
        descTicket.push(this.$t("UnlimitedTripPerDayDesc").replace("[num]", this.fareRule.max_trip_perday))
      }

      if (this.fareRule.selling_close_date != null && this.fareRule.selling_close_date != "") {
        descTicket.push(this.$t("SellingPeriodDesc").replace("[date]", moment(this.fareRule.selling_close_date).format("DD MMMM YYYY")))
      }

      if (this.fareRule.validate_close_date == null || this.fareRule.validate_close_date == "") {
        descTicket.push(this.$t("ValidationPeriodWihoutCloseDesc").replace("[date]", moment(this.fareRule.selling_open_date).format("DD MMMM YYYY")))
      } else {
        descTicket.push(this.$t("ValidationPeriodDesc")
          .replace("[date1]", moment(this.fareRule.validate_open_date).format("DD MMMM YYYY"))
          .replace("[date2]", moment(this.fareRule.validate_close_date).format("DD MMMM YYYY"))
        )
      }

      return descTicket
    },
    selectedCurrency() {
      return this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.code : ""
    }
  },
  mounted() {
  },
};
</script>

<style scoped>
.rounded-card {
  border-radius: 15px;
}

.header-title {
  font-weight: bold;
  font-size: 20px;
}

.dots-line {
    border: 1px dashed #ccc;
}

.route-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  margin-bottom: -5px;

  color: #000000;
}

.detail-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  display: flex;
  align-items: center;
  margin-top: -40px;
  margin-bottom: -20px;
  color: #000000;
}

.ticket {
  font-weight: bold;
  font-size: 24px;
  line-height: 118.88%;

  color: #489E4B;
}


.name-loc {
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 118.88%;
  /* identical to box height, or 31px */

  text-transform: capitalize;

  color: #489e4b;
}

.name-location {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-transform: capitalize;

  color: #4bb14e;
}

.detail-route {
  font-size: 10px;
  color: #4bb14e;
  text-align: center;
}

.num-135000-v-nd {
  font-size: 24px;
  font-weight: 700;
  color: #fe7e41;
}

</style>